import React from 'react';
import image from '../../../Assets/Cards/imacDemo.webp';
import  imac from '../../../Assets/Icons/imac.svg';
import AppPart from '../../Shared/AppPart/AppPart';

const Demo=()=>{
    return(
        <>
        <AppPart 
        title="The world's most innovative companies use HostDesOur apps let you create, play and share on the go."
        desc="Our apps let you create, play and share on the go."
        backgroundImage1 = {imac}
        image={image}
        />
        </>
    )
};
export default Demo ;